"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("../../Text"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Error = function Error(props) {
  return _react.default.createElement(_Text.default, (0, _tslib.__assign)({}, props, {
    color: "red",
    pb: 1,
    fontSize: "smaller"
  }));
};

Error.displayName = 'Error';
var _default = Error;
exports.default = _default;